export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/reel-a135b45f5614e27978ae233cd04884a1.png";